module.exports = __webpack_public_path__ + "2ee683e699b75a8972675e05c429d0ab.svg";